module.exports = __webpack_public_path__ + "static/media/invest2.a9333a06.svg";